<template>
  <div class="container-fluid">
    <div class="mt17">
      <div class="card">
        <div class="card-content">
          <img class="help-image" src="../../assets/help.jpg" alt="Help">

          <div class="help-container">
            <h2 class="help-title">{{$t('labels.help')}}</h2>

            <p class="field-label">{{$t('labels.topic')}}</p>
            <select-drop-down
              class="mb10"
              v-model="selectedTopic"
              gradient="merchant"
              :placeholder="$t('labels.select_topic')"
              :options="topics"
              :hint="$t('labels.select_topic')"
            ></select-drop-down>

            <p class="field-label">{{$t('labels.subject')}}</p>
            <underlined-input
              class="mb10 header-underlined-input"
              v-model="subject"
              :size="100"
              color="grey"
              :name="$t('labels.subject')"
              :placeholder="$t('labels.subject')"
              :validation="validation.subject"
            />

            <div>
              <p class="field-label">{{$t('labels.message')}}</p>
              <textarea
                class="material-input"
                v-model="text"
                rows="10"
                :name="$t('labels.message')"
                v-validate="validation.text"
              ></textarea>
            </div>

            <div class="flex center">
              <donapp-button
                :disabled="$validator.errors.items.length > 0 || loading || !selectedTopic"
                :text="$t('labels.send')"
                :disabledAction="() => tryToSubmit = true"
                :action="send"
                class="gradient-merchant"
              ></donapp-button>
              <span
                class="error"
                v-if="($validator.errors.items.length > 0 || !selectedTopic) && !loading && tryToSubmit"
              >{{ errorMsg }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UnderlinedInput from '@/components/shared/inputs/UnderlinedInput'
import SelectDropDown from '@/components/shared/inputs/SelectDropDown'
import DonappButton from '@/components/shared/buttons/Button'
import apiService from '@/services/ApiService'

export default {
  name: 'help',
  components: {
    UnderlinedInput,
    SelectDropDown,
    DonappButton
  },
  $_veeValidate: {
    validator: 'new' // give me a new validator each time.
  },
  async mounted() {
    await this.$validator.validateAll()
  },
  data() {
    return {
      // TODO: TOPICS LOCALIZATION
      topics: ['DonapPos', 'Metodo di Pagamento', 'Benefici Fiscali', 'Account', 'Altro'],
      tryToSubmit: false,
      selectedTopic: null,
      subject: '',
      text: '',
      loading: false,
      validation: {
        subject: 'required|min:1',
        text: 'required|min:1'
      }
    }
  },
  computed: {
    errorMsg: function() {
      return this.$validator.errors.items
        .map(item => item.msg)
        .concat(this.selectedTopic ? [] : 'Il campo ' + this.$i18n.t('labels.topic') + ' è richiesto.')
        .join(' ')
    }
  },
  methods: {
    async send() {
      this.loading = true
      const allOK = await this.$validator.validateAll()
      if (allOK) {
        try {
          const { data: result } = await apiService.sendHelpMessage(
            {
              topic: this.selectedTopic,
              subject: this.subject,
              text: this.text
            },
            'merchants'
          )
          if (!result.success) this.$toasted.error(result.error.message)
          else {
            this.$toasted.success(this.$i18n.t('messages.help_request_sent'))
            this.selectedTopic = undefined
            this.subject = ''
            this.text = ''
          }
        } catch (error) {
          this.$toasted.error(error.message)
        }
      }
      this.loading = false
      this.tryToSubmit = false
      await this.$validator.validateAll()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/config.scss';

.card-content {
  text-align: left;
  padding: 17px;
  display: flex;
  // flex-direction: column;

  .error {
    color: red;
    align-self: center;
    margin-left: 8px;
  }

  .help-title {
    @include biggestFontSize();
    font-weight: 700;
    letter-spacing: 1.05px;
    line-height: 21px;
    padding-bottom: 17px;
    flex: 0 1 100%;
    margin: 0;
  }

  .field-label {
    font-size: 17px;
    color: $grey;
    // padding-top: 8px;
  }
  .field-value {
    padding-bottom: 8px;
    text-transform: capitalize;
  }
  .field-divider {
    border-bottom: 1px solid #d9dadb;
  }

  .help-image {
    width: 325px;
    height: 325px;
    margin-top: -34px;
    overflow: hidden;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    object-fit: cover;
    min-height: 100px;
    min-width: 100px;

    @include shadow();
    @include borderRadius();
  }

  .help-container {
    flex-grow: 1;
    padding-left: 17px;
  }

  .half {
    width: 50%;
  }
  .full {
    width: 100%;
  }
  textarea {
    width: 100%;
    border-color: $dividerGrey;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/merchants/Help.vue